import React from "react";
import { Component } from "react";
import styles from "./classcss/classsidebar.module.css";
import CourseModal from "./CourseModal";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import StartLive from "../../../components/commons/StartLive";
import { ModalWithHeader } from "../../../components/shared/ui/Modal/Modal";
import { connect } from "react-redux";
import { store } from "../../../redux/store";
import {
  updateMission,
  getClassDetails,
  getMyGroups,
} from "../../../redux/actions/classes";
import { getGroupDetails, getGroupPosts } from "../../../redux/actions/groups";
import { withTranslation } from "react-i18next";
import { handleErrorMessage } from "../../../redux/actions/dashboard";
import { handleSuccessMessage } from "../../../redux/actions/success";

class ClassSidebar extends Component {
  constructor() {
    super();
    this.state = {
      course: "",
      link: "",
      src: "",
      isPostActiveSection: true,
      showCourseModal: false,
      activeSubject: "",
      showWelcomeModal: false,
      showClassMenu: false,
      myClasses: [],
      myCourses: [],
      showModal: false,
      missionText: "",
      numOfPost: 0,
      numOfAssignmentAndQuiz: null,
    };
  }
  componentDidMount() {
    this.props.getMyGroups();

    this.setState({
      myClasses: this.props.myClasses,
      myCourses: this.props.myCourses,
      activeSubject: this.props.subjectName,
      missionText: this.props.group_objective,
      numOfPost:
        this.props.routeType === "Class"
          ? this.props.classPost
          : this.props.groupPost,
      numOfAssignmentAndQuiz:
        this.props.routeType === "Class"
          ? this.props.classAssignments + this.props.classQuizzes
          : // ? this.props.classAssignmentsQuizzes
            0,
    });
  }
  componentDidUpdate() {
    if (
      this.state.myCourses !== this.props.myCourses ||
      this.state.myClasses !== this.props.myClasses
    ) {
      this.setState({
        myClasses: this.props.myClasses,
        myGroups: this.props.myGroups,
        myCourses: this.props.myCourses,
        activeSubject: this.props.subjectName,
        missionText:
          this.props.routeType === "Class"
            ? this.props.vision_mission
            : this.props.group_objective,
        numOfPost:
          this.props.routeType === "Class"
            ? this.props.classPost
            : this.props.groupPost,
      });
    }
  }
  WelcomeModalOpener = () => {
    this.setState({ showWelcomeModal: true });
  };
  CourseModalCloser = () => {
    this.setState({ showCourseModal: false });
  };
  CourseModalOpener = () => {
    this.setState({ showCourseModal: true });
  };
  toogleMenu1 = () => {
    this.props.getMyGroups();
    this.setState({
      showClassMenu: !this.state.showClassMenu,
    });
  };
  changeActiveSect = (selectedSection) => {
    if (this.props.activeSection != selectedSection) {
      this.props.changeActiveSection(selectedSection);
    }
  };
  changeSelectedSubject = (myClass) => {
    this.setState({
      showClassMenu: false,
    });
    this.props.getMyGroups();
    this.props.getActiveClassDetails(myClass);
    this.props.getGroupPosts(myClass);
    this.props.handleSuccessMessage("Group Changed");
  };

  Myclasses = () => {
    const owner = store?.getState()?.profile?.user?.profile_id;
    if (this.state.showClassMenu) {
      console.log("line110", this.state.myGroups);
      const ClassesList = () => (
        <ul>
          {this.state.myGroups.map((myClass, index) => (
            <div
              className={styles.menu1}
              onClick={() => this.changeSelectedSubject(myClass.id)}
              key={index}
            >
              <li
                className={styles.classList}
                style={{
                  marginTop: 6,
                  marginBottom: 6,
                  color:
                    this.props.subjectName !== myClass.name
                      ? "#555555"
                      : "var(--secondary-main)",
                }}
              >
                {myClass.name}
              </li>
              {index < this.state.myClasses.length - 1 ? (
                <hr className={styles.ClassHr} />
              ) : null}
            </div>
          ))}
        </ul>
      );
      return (
        <div className={styles.dropdown_menu1}>
          <ClassesList />
        </div>
      );
    } else return <></>;
  };
  MyCourses = () => {
    return this.state.myCourses.map((myCourse, index) => (
      <>
        <div className={styles.Classsidebar_stat1} key={index}>
          <img
            src={myCourse.src}
            style={{ width: 48, height: 48, borderRadius: 50 }}
          />
          <p className={styles.Classsidebar_statNumber}>
            {myCourse.link != "" ? (
              <a
                href={myCourse.link}
                target="_blank"
                className={styles.onhover}
                style={{ textDecoration: "none", fontSize: 14 }}
              >
                {myCourse.title}
              </a>
            ) : (
              <p
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  fontSize: 14,
                }}
              >
                {myCourse.title}
              </p>
            )}
          </p>
        </div>
        {index < this.state.myCourses.length - 1 ? (
          <hr className={styles.ClassHr} />
        ) : null}
      </>
    ));
  };
  handleMission = () => {
    const { t } = this.props;

    if (this.state.missionText?.trim() != "") {
      let payload = {
        missionText: this.state.missionText,
        classId:
          this.props.routeType === "Class"
            ? this.props.class_id
            : this.props.group_id,
        routeType: this.props.routeType,
      };

      const onSucess = () => {
        this.setState({ showModal: false, missionText: "" });
      };
      const onError = (error) => {
        this.setState({ showModal: false, missionText: "" });
      };
      updateMission(payload, onSucess, onError);
    } else {
      if (this.props.routeType == "Class") {
        this.props.handleErrorMessage(t("class.emptyMissionVision"));
      } else {
        this.props.handleErrorMessage(t("group.emptyObjective"));
      }
    }
  };
  render() {
    let productCount = 0;
    const { t } = this.props;
    this.state.isPostActiveSection = this.props.activeSection == "Post";
    productCount = this?.props?.courseCount;
    return (
      <div className={styles.Class_Sidebar}>
        <CourseModal
          title={t("classGroup.addCourseLink")}
          closeModal={this.CourseModalCloser}
          show={this.state.showCourseModal}
          getActiveClassDetails={this.props.getActiveClassDetails}
        />
        <ModalWithHeader
          title={
            this.props.routeType === "Class"
              ? t("class.addMissionVision")
              : t("group.addObjective")
          }
          show={this.state.showModal}
          closeHandler={() => {
            this.setState({ showModal: false });
          }}
        >
          <div className={styles.classModal}>
            <div className={styles.formFields}>
              <h3 className={styles.inputLabel} for="classname">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    font: "normal normal 500 16px Montserrat",
                    letteSpacing: "0px",
                    color: "#000000",
                  }}
                >
                  <img
                    style={{ marginRight: "10px" }}
                    src="/Image/modalIcon/mission.svg"
                  />
                  {this.props.routeType === "Class"
                    ? t("class.missionVision")
                    : t("group.objective")}
                </div>
              </h3>
              <textarea
                className={`${styles.inputLabel} ${styles.textarea}`}
                onChange={(e) => this.setState({ missionText: e.target.value })}
                type="textarea"
                // className={styles.textarea}
                rows="6"
                placeholder={`${t("common.exDescribeYour")} ${
                  this.props.routeType === "Class"
                    ? t("class.missionVision")
                    : t("group.objective")
                }`}
                value={this.state.missionText}
              ></textarea>
              <button
                onClick={() => {
                  this.handleMission(this.missionText);
                }}
                id="submitForm"
                className={styles.saveDetailsButton}
              >
                {t("common.save")}
              </button>
            </div>
          </div>
        </ModalWithHeader>
        {/* Mission */}
        <div className={styles.Classsidebar_mycontent}>
          <div className={styles.Class_side}>
            <img
              src="/Image/Group/Asset 9.svg"
              // className={styles.Classsidebar_icon1}
              style={{ width: 35, height: 35, cursor: "pointer" }}
            />
            <h3 style={{ marginLeft: 15, fontSize: 20, color: "gray" }}>
              {this.props.routeType === "Class"
                ? t("class.missionVision")
                : t("group.objective")}
            </h3>
          </div>
        </div>

        <div className={styles.Classsidebar_stats}>
          {this.props.routeType === "Class" ? (
            <p
              style={{
                color: "#555555",
                padding: "15px 30px",
                margin: 0,
                fontSize: "14px",
                textAlign: "center",
              }}
            >
              {this.props.vision_mission == ""
                ? t("class.addYourMissionVision")
                : this.props.vision_mission}
            </p>
          ) : (
            <p
              style={{
                color: "#555555",
                padding: "15px 30px",
                margin: 0,
                fontSize: "14px",
                textAlign: "center",
                wordWrap: "break-word",
              }}
            >
              {this.props.groupVision == "" || !this.props.groupVision
                ? t("group.addYourObjective")
                : this.props.groupVision}
            </p>
          )}

          <hr className={styles.ClassHr} />
          <div className={styles.sidebar_stat1}>
            <p
              onClick={() => {
                this.setState({ showModal: true });
              }}
            >
              <span style={{ marginLeft: 5 }}>
                {this.props.routeType === "Class"
                  ? t("class.editMissionVision")
                  : t("group.editObjective")}
              </span>
            </p>
          </div>
        </div>
        {/* Mission */}

        <div className={styles.Classsidebar_mycontent}>
          <div className={styles.Class_side}>
            <img
              src="/Image/Group/Asset 10.svg"
              // className={styles.Classsidebar_icon1}
              style={{ width: 35, height: 35, cursor: "pointer" }}
            />
            <h3 style={{ marginLeft: 15, fontSize: 20, color: "gray" }}>{`${
              this.props.routeType === "Class"
                ? t("common.myClasses")
                : t("common.myGroupActivity")
              // : t("common.myGroups")
            }`}</h3>
          </div>
          {this.state.myGroups?.length > 1 ? (
            <div className={styles.Classnavbar_menu1}>
              <MoreHorizIcon
                onClick={this.toogleMenu1}
                className={styles.Classsidebar_icon2}
                style={{ marginTop: 7, cursor: "pointer" }}
              />
              <this.Myclasses />
            </div>
          ) : (
            <div className={styles.Classnavbar_menu1}>
              <MoreHorizIcon
                onClick={this.toogleMenu1}
                className={styles.Classsidebar_icon2}
                style={{ marginTop: 7, cursor: "pointer" }}
              />
              <this.Myclasses />
            </div>
          )}
        </div>

        {/* POST Section */}

        <div className={styles.Classsidebar_stats}>
          <div
            className={styles.Classsidebar_stat}
            onClick={() => this.changeActiveSect("Post")}
          >
            <p
              style={{
                color:
                  this.props.activeSection == "Post"
                    ? "var(--secondary-main)"
                    : "black",
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 10,
                paddingRight: 10,
                margin: 0,
                fontWeight: this.props.activeSection == "Post" ? 600 : 400,
              }}
            >
              {t("common.post")}
            </p>
            <p
              style={{
                color: "var(--secondary-main)",
                fontWeight: 600,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 10,
                paddingRight: 10,
                margin: 0,
                fontWeight: this.props.activeSection == "Post" ? 600 : 400,
              }}
            >
              {this.state.numOfPost}
            </p>
          </div>
          {/* <hr className={styles.ClassHr} /> */}

          {/* Assignmenet and Quiz section */}
          {/* {this.props.routeType === "Class" ? ( */}
          {/* <div
            className={styles.Classsidebar_stat}
            onClick={() => this.changeActiveSect("Assignments")}
          >
            <p
              style={{
                color:
                  this.props.activeSection == "Assignments"
                    ? "#F33070"
                    : "black",
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 10,
                paddingRight: 10,
                margin: 0,
                fontWeight: this.props.activeSection == "Assignments"
                ? 600 : 400,
              }}
            >
              {t("common.assignmentAndQuiz")}
            </p>
            <p
              style={{
                color: "#F33070",
                fontWeight: 600,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 10,
                paddingRight: 10,
                margin: 0,
                fontWeight: this.props.activeSection == "Assignments"
                ? 600 : 400,
              }}
            >
              {this.props.classAssignments + this.props.classQuizzes}
              
            </p>
          </div> 

          {/* Courses Section */}
          {/* {window.location.pathname.split("/")[1] == "class" && (
            <hr className={styles.ClassHr} />
          )} */}

          {/* {window.location.pathname.split("/")[1] == "class" && ( */}
          {/* {true && (
            <div
              className={styles.Classsidebar_stat}
              onClick={() => this.changeActiveSect("Courses")}
            >
              <p
                style={{
                  color:
                    this.props.activeSection == "Courses" ? "#0267c8" : "black",
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingLeft: 10,
                  paddingRight: 10,
                  margin: 0,
                  fontWeight: this.props.activeSection == "Courses" ? 600 : 400,
                }}
              >
                {t("common.productServices")} Listing
              </p>


              <p
                style={{
                  color: "#0267c8",
                  fontWeight: 600,
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingLeft: 10,
                  paddingRight: 10,
                  margin: 0,
                  fontWeight: this.props.activeSection == "Courses" ? 600 : 400,
                }}
              >

                {productCount ? productCount[0]?.length : productCount}
              </p>
            </div>
          )} */}
          <hr className={styles.ClassHr} />
          {/* ) : null} */}
          {this.props.routeType === "Class" ? (
            <hr className={styles.ClassHr} />
          ) : null}

          {/* --- assignment quiz ends --- */}

          <div
            className={styles.Classsidebar_stat}
            onClick={() => this.changeActiveSect("Members")}
          >
            <p
              style={{
                color:
                  this.props.activeSection == "Members"
                    ? "var(--secondary-main)"
                    : "black",
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 10,
                paddingRight: 10,
                margin: 0,
                fontWeight: this.props.activeSection == "Members" ? 600 : 400,
              }}
            >
              {t("common.members")}
            </p>
            <p
              style={{
                color: "var(--secondary-main)",
                fontWeight: 600,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 10,
                paddingRight: 10,
                margin: 0,
                fontWeight: this.props.activeSection == "Members" ? 600 : 400,
              }}
            >
              {this.props.numOfMembers}
            </p>
          </div>
          {/* <hr className={styles.ClassHr} /> */}
          {/* <div
            className={styles.Classsidebar_stat}
            onClick={() => this.changeActiveSect("Recordings")}
          >
            <p
              style={{
                color:
                  this.props.activeSection == "Recordings"
                    ? "var(--secondary-main)"
                    : "black",
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 10,
                paddingRight: 10,
                margin: 0,
                fontWeight:
                  this.props.activeSection == "Recordings" ? 600 : 400,
              }}
            >
              {t("common.recordings")}
            </p>
            <p
              style={{
                color: "var(--secondary-main)",
                fontWeight: 600,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 10,
                paddingRight: 10,
                margin: 0,
                fontWeight:
                  this.props.activeSection == "Recordings" ? 600 : 400,
              }}
            >
              {this.props?.meetings?.length}
            </p>
          </div> */}
        </div>
        <StartLive
          startLiveText={
            this.props.routeType === "Class"
              ? t("class.liveClass")
              : t("group.liveDiscussion")
          }
          source={this.props.routeType === "Class" ? "CLASS" : "GROUP"}
        />

        {/* <div className={styles.Classsidebar_mycontent}>
          <div className={styles.Class_side}>
            <img
              src="/Image/DashImage/Chalkmate_Courses.svg"
              className={styles.Classsidebar_icon1}
              style={{ width: 35, height: 35, cursor: "pointer" }}
            />
            <h3 style={{ marginLeft: 15, fontSize: 16 }}>
              {t("common.courses")}
            </h3>
          </div>
        </div>

        <div className={styles.Classsidebar_stats}>
          {this.props.myCourses.length > 0 ? (
            <this.MyCourses />
          ) : (
            <p style={{ color: "#555555", fontSize: "13px", margin: "15px 0" }}>
              {this.props.routeType === "Class"
                ? t("class.createCourseDesc")
                : t("group.createCourseDesc")}
            </p>
          )}
          <hr className={styles.ClassHr} />
          <div className={styles.sidebar_stat1}>
            <p onClick={this.CourseModalOpener}>
              <AddIcon style={{ width: 24, height: 24 }} />
              <span style={{ marginLeft: 5 }}>{t("class.createCourse")}</span>
            </p>
          </div>
        </div> */}
      </div>
    );
  }
}

/* export default ClassSidebar; */
const mapStateToProps = (state) => {
  return {
    groupVision: state.groups.group.groupVision,
    classPost: state?.classes?.posts?.length,
    groupPost: state?.groups?.posts?.length,
    classAssignments: state?.assignment?.assignments?.length,
    classQuizzes: state?.quiz?.quizzes?.length,
    courseCount: state?.groups?.productService,
    myGroups:
      state?.groups?.myGroups?.map((each_group) => {
        return {
          name: each_group?.groups?.name,
          id: each_group?.groups?.id,
          group_type: each_group?.groups?.group_type,
          group_owner: each_group?.groups?.group_owner,
        };
      }) || [],
    // classAssignmentsQuizzes: state?.assignment?.allAssignmentQuiz?.length,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateMission: (data, onSucess, onError) =>
      dispatch(updateMission(data, onSucess, onError)),
    getClassDetails: (id) => dispatch(getClassDetails(id)),
    getGroupDetails: (id) => dispatch(getGroupDetails(id)),
    getGroupPosts: (id) => dispatch(getGroupPosts(id)),
    getMyGroups: () => dispatch(getMyGroups()),
    handleErrorMessage: (error) => dispatch(handleErrorMessage(error)),
    handleSuccessMessage: (error) => dispatch(handleSuccessMessage(error)),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ClassSidebar)
);
